import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  MappingHistory,
  MappingHistoryPayload,
} from "../models/mappingHistory.model";
import { EndpointService } from "./endpoint.service";

@Injectable({
  providedIn: "root",
})
export class MappingHistoryService extends EndpointService {
  constructor(http: HttpClient) {
    super(http);
  }

  getMappingHistory(payload: MappingHistoryPayload) {
    return this.http.post<MappingHistory[]>(
      this.getApiUrl("MappingHistory/GetMappingHistory"),
      payload
    );
  }
}
